export const hi = {
  nav: { services: "सेवाएँ", sectors: "क्षेत्र", loans: "ऋण", team: "नेतृत्व", contact: "संपर्क", cta: "वित्तपोषण का अनुरोध करें" },
  hero: {
    eyebrow: "कनाडाई संस्थागत पूंजी",
    line1: "ऐसी पूंजी जो उद्योगों को",
    line2: "आगे बढ़ाती है",
    sub: "पैसिफ़िक इन्वेस्टमेंट ग्रुप सात प्रमुख क्षेत्रों में बड़े पैमाने का निवेश, ऋण और रणनीतिक साझेदारी संचालित करता है — कृषि और शिक्षा से लेकर बुनियादी ढांचे और उड्डयन तक।",
    cta1: "वित्तपोषण का अनुरोध करें",
    cta2: "हमारी सेवाएँ देखें",
    scroll: "खोजने के लिए स्क्रॉल करें",
    m1: "निवेशित पूंजी",
    m2: "वित्तपोषित परियोजनाएँ",
    m3: "ग्राहक संतुष्टि",
    m4: "मुख्य क्षेत्र",
  },
  services: {
    eyebrow: "हम क्या करते हैं",
    title: "निर्माण के तीन तरीके",
    sub: "संस्थागत पूंजी, उन उद्यमों के लिए संरचित जो दुनिया को चलाते हैं।",
    s1t: "निवेश",
    s1d: "संस्थागत इक्विटी और संयुक्त उपक्रम जो आशाजनक उद्यमों को क्षेत्रीय नेता बनाते हैं।",
    s1f1: "इक्विटी और संयुक्त उपक्रम",
    s1f2: "परियोजना संरचना",
    s1f3: "दीर्घकालिक वृद्धि",
    s2t: "ऋण",
    s2d: "छोटे और बड़े व्यवसायों के लिए बड़े पैमाने का ऋण वित्तपोषण — वृद्धि के लिए संरचित वाणिज्यिक ऋण।",
    s2f1: "$500K से $100M+",
    s2f2: "तेज़ स्वीकृति",
    s2f3: "लचीला भुगतान",
    s3t: "साझेदारी",
    s3d: "व्यावहारिक परिचालन मार्गदर्शन और वैश्विक नेटवर्क के साथ रणनीतिक सह-निवेश।",
    s3f1: "सह-निवेश मॉडल",
    s3f2: "परिचालन मार्गदर्शन",
    s3f3: "वैश्विक नेटवर्क",
  },
  sectors: {
    eyebrow: "हम कहाँ निवेश करते हैं",
    title: "सात क्षेत्र। एक मानक।",
    sub: "हम उन उद्योगों में बड़े पैमाने की पूंजी लगाते हैं जो अगली सदी का आकार तय करेंगे।",
    ag: "कृषि", agd: "आधुनिक एगटेक और बड़े पैमाने पर टिकाऊ खेती।",
    edu: "शिक्षा", edud: "परिसर विकास और नई पीढ़ी का शैक्षिक बुनियादी ढांचा।",
    re: "रियल एस्टेट", red: "वाणिज्यिक, आवासीय और संयुक्त उपयोग विकास पूंजी।",
    ind: "औद्योगिक विकास", indd: "निर्माण संयंत्र, लॉजिस्टिक्स पार्क और औद्योगिक क्षेत्र।",
    inf: "बुनियादी ढांचा", infd: "परिवहन गलियारे, ऊर्जा संपदा और सार्वजनिक उपयोगिताएँ।",
    aut: "ऑटोमेशन", autd: "रोबोटिक्स और एआई-संचालित निर्माण प्रणालियाँ।",
    avi: "उड्डयन", avid: "विमान लीजिंग, बेड़ा वित्तपोषण और हवाई अड्डा विकास।",
  },
  loans: {
    eyebrow: "ऋण वित्तपोषण",
    title: "गंभीर व्यवसायों के लिए बड़े पैमाने के ऋण।",
    desc: "$500K से $100M+ तक, हम छोटे और बड़े व्यवसायों के लिए वाणिज्यिक ऋण की संरचना करते हैं — तेज़ स्वीकृति, लचीला भुगतान और आपकी इक्विटी की सुरक्षा करने वाली शर्तें।",
    f1: "लचीली चुकौती शर्तें",
    f2: "तेज़ स्वीकृति प्रक्रिया",
    f3: "प्रतिस्पर्धी दरें",
    f4: "इक्विटी का पतन नहीं",
    slider: "आपकी वित्तपोषण आवश्यकता",
    cta: "ऋण पूछताछ शुरू करें",
    steps: "पूछताछ → समीक्षा → स्वीकृति → वित्तपोषण",
  },
  stats: { l1: "निवेशित पूंजी", l2: "वित्तपोषित परियोजनाएँ", l3: "ग्राहक संतुष्टि", l4: "मुख्य क्षेत्र" },
  marquee: ["निवेश", "कृषि", "ऋण", "शिक्षा", "साझेदारी", "रियल एस्टेट", "बुनियादी ढांचा", "ऑटोमेशन", "उड्डयन"],
  team: {
    eyebrow: "नेतृत्व",
    title: "पूंजी के पीछे के लोग।",
    sub: "वैश्विक बाज़ारों में दशकों के अनुभव वाली विविध कार्यकारी टीम।",
    r1: "मुख्य कार्यकारी अधिकारी (CEO)",
    r2: "वरिष्ठ उपाध्यक्ष, वैश्विक निवेश",
    r3: "बुनियादी ढांचा और ऋण वित्तपोषण प्रमुख",
    r4: "निदेशक, रियल एस्टेट और सतत विकास",
    r5: "मुख्य वित्तीय अधिकारी (CFO)",
    r6: "मुख्य विधि सलाहकार और अनुपालन",
  },
  form: {
    eyebrow: "संपर्क करें",
    title: "हमें अपनी परियोजना के बारे में बताएं।",
    sub: "कुछ विवरण साझा करें और हमारी टीम एक कार्यदिवस में उत्तर देगी।",
    name: "पूरा नाम",
    email: "ईमेल पता",
    phone: "फ़ोन",
    company: "कंपनी",
    service: "मुझे रुचि है",
    sector: "क्षेत्र",
    amount: "वित्तपोषण राशि",
    amountPh: "जैसे $2.5M",
    message: "आपकी परियोजना के बारे में",
    messagePh: "अपने व्यवसाय और वित्तपोषण आवश्यकताओं के बारे में संक्षेप में बताएं…",
    pick: "एक क्षेत्र चुनें",
    submit: "पूछताछ भेजें",
    submitting: "भेजा जा रहा है…",
    success: "पूछताछ प्राप्त हुई — हमारी टीम 24 घंटों में संपर्क करेगी।",
    error: "कुछ गलत हो गया। कृपया पुनः प्रयास करें या WhatsApp पर संपर्क करें।",
    required: "कृपया अपना नाम, ईमेल और संदेश भरें।",
    invalidEmail: "कृपया एक वैध ईमेल पता दर्ज करें।",
    safe: "आपकी जानकारी हमेशा गोपनीय रखी जाती है और 100% सुरक्षित रहती है।",
  },
  contact: {
    eyebrow: "संपर्क",
    title: "सीधे हमसे बात करें।",
    whatsapp: "व्हाट्सएप",
    waCta: "WhatsApp पर चैट करें",
    email: "ईमेल",
    emCta: "ईमेल भेजें",
    address: "कार्यालय",
    dir: "मार्गदर्शन प्राप्त करें",
    hours: "सोम–शुक्र, 9:00–18:00 EST",
  },
  footer: {
    tagline: "कल का आकार तय करने वाले क्षेत्रों के लिए संस्थागत पूंजी।",
    rights: "© 2026 पैसिफ़िक इन्वेस्टमेंट ग्रुप। सर्वाधिकार सुरक्षित।",
    privacy: "गोपनीयता",
    disclaimer: "पैसिफ़िक इन्वेस्टमेंट ग्रुप वाणिज्यिक वित्तपोषण और निवेश सेवाएँ प्रदान करता है। सभी पूछताछ समीक्षा और स्वीकृति के अधीन हैं।",
  },
};

export const ru = {
  nav: { services: "Услуги", sectors: "Секторы", loans: "Кредиты", team: "Руководство", contact: "Контакты", cta: "Запросить финансирование" },
  hero: {
    eyebrow: "Канадский институциональный капитал",
    line1: "Капитал, который двигает",
    line2: "индустрии вперёд",
    sub: "Pacific Investment Group разворачивает масштабные инвестиции, кредиты и стратегические партнёрства в семи ключевых секторах — от сельского хозяйства и образования до инфраструктуры и авиации.",
    cta1: "Запросить финансирование",
    cta2: "Наши услуги",
    scroll: "Прокрутите вниз",
    m1: "Инвестировано капитала",
    m2: "Профинансировано проектов",
    m3: "Довольных клиентов",
    m4: "Ключевых секторов",
  },
  services: {
    eyebrow: "Чем мы занимаемся",
    title: "Три способа строить",
    sub: "Институциональный капитал, структурированный для компаний, на которых держится мир.",
    s1t: "Инвестиции",
    s1d: "Институциональный акционерный капитал и совместные предприятия, превращающие перспективные компании в лидеров отрасли.",
    s1f1: "Акционерный капитал и СП",
    s1f2: "Структурирование проектов",
    s1f3: "Долгосрочный рост",
    s2t: "Кредиты",
    s2d: "Масштабное долговое финансирование для малого и крупного бизнеса — коммерческие кредиты, структурированные под рост.",
    s2f1: "От $500K до $100M+",
    s2f2: "Быстрое одобрение",
    s2f3: "Гибкое погашение",
    s3t: "Партнёрство",
    s3d: "Стратегические совместные инвестиции с практической операционной поддержкой и глобальными сетями.",
    s3f1: "Модели соинвестирования",
    s3f2: "Операционная поддержка",
    s3f3: "Глобальные сети",
  },
  sectors: {
    eyebrow: "Куда мы инвестируем",
    title: "Семь секторов. Один стандарт.",
    sub: "Мы направляем крупный капитал в индустрии, которые формируют следующий век.",
    ag: "Сельское хозяйство", agd: "Современные агротехнологии и устойчивое фермерство в масштабе.",
    edu: "Образование", edud: "Развитие кампусов и учебная инфраструктура нового поколения.",
    re: "Недвижимость", red: "Капитал для коммерческой, жилой и смешанной застройки.",
    ind: "Промышленное развитие", indd: "Заводы, логистические парки и промышленные зоны.",
    inf: "Инфраструктура", infd: "Транспортные коридоры, энергетические активы и коммунальные системы.",
    aut: "Автоматизация", autd: "Робототехника и системы производства на базе ИИ.",
    avi: "Авиация", avid: "Лизинг самолётов, финансирование флота и развитие аэропортов.",
  },
  loans: {
    eyebrow: "Долговое финансирование",
    title: "Крупные кредиты для серьёзного бизнеса.",
    desc: "От $500K до $100M и выше — мы структурируем коммерческий долг для малого и крупного бизнеса: быстрое одобрение, гибкое погашение и условия, защищающие ваш капитал.",
    f1: "Гибкие условия погашения",
    f2: "Быстрый процесс одобрения",
    f3: "Конкурентные ставки",
    f4: "Без размытия доли",
    slider: "Ваша потребность в финансировании",
    cta: "Начать кредитную заявку",
    steps: "Заявка → Рассмотрение → Одобрение → Финансирование",
  },
  stats: { l1: "Инвестировано капитала", l2: "Профинансировано проектов", l3: "Довольных клиентов", l4: "Ключевых секторов" },
  marquee: ["Инвестиции", "Сельское хозяйство", "Кредиты", "Образование", "Партнёрство", "Недвижимость", "Инфраструктура", "Автоматизация", "Авиация"],
  team: {
    eyebrow: "Руководство",
    title: "Люди, стоящие за капиталом.",
    sub: "Разнообразная управленческая команда с десятилетиями опыта на глобальных рынках.",
    r1: "Главный исполнительный директор (CEO)",
    r2: "Старший вице-президент, глобальные инвестиции",
    r3: "Руководитель инфраструктуры и долгового финансирования",
    r4: "Директор, недвижимость и устойчивое развитие",
    r5: "Финансовый директор (CFO)",
    r6: "Директор по юридическим вопросам и комплаенсу",
  },
  form: {
    eyebrow: "Свяжитесь с нами",
    title: "Расскажите о своём проекте.",
    sub: "Поделитесь деталями, и наша команда ответит в течение одного рабочего дня.",
    name: "Полное имя",
    email: "Электронная почта",
    phone: "Телефон",
    company: "Компания",
    service: "Меня интересует",
    sector: "Сектор",
    amount: "Сумма финансирования",
    amountPh: "напр. $2.5M",
    message: "О вашем проекте",
    messagePh: "Кратко расскажите о вашем бизнесе и потребностях в финансировании…",
    pick: "Выберите сектор",
    submit: "Отправить заявку",
    submitting: "Отправка…",
    success: "Заявка получена — наша команда свяжется с вами в течение 24 часов.",
    error: "Что-то пошло не так. Попробуйте снова или напишите нам в WhatsApp.",
    required: "Пожалуйста, заполните имя, почту и сообщение.",
    invalidEmail: "Пожалуйста, введите корректный адрес электронной почты.",
    safe: "Ваша информация всегда хранится в полной конфиденциальности и на 100% в безопасности.",
  },
  contact: {
    eyebrow: "Контакты",
    title: "Поговорите с нами напрямую.",
    whatsapp: "WhatsApp",
    waCta: "Написать в WhatsApp",
    email: "Эл. почта",
    emCta: "Отправить письмо",
    address: "Офис",
    dir: "Построить маршрут",
    hours: "Пн–Пт, 9:00–18:00 EST",
  },
  footer: {
    tagline: "Институциональный капитал для секторов, формирующих завтрашний день.",
    rights: "© 2026 Pacific Investment Group. Все права защищены.",
    privacy: "Конфиденциальность",
    disclaimer: "Pacific Investment Group предоставляет услуги коммерческого финансирования и инвестиций. Все заявки подлежат рассмотрению и одобрению.",
  },
};

export const ja = {
  nav: { services: "サービス", sectors: "セクター", loans: "融資", team: "経営陣", contact: "お問い合わせ", cta: "資金調達の相談" },
  hero: {
    eyebrow: "カナダの機関投資キャピタル",
    line1: "産業を前へ進める",
    line2: "資本の力",
    sub: "パシフィック・インベストメント・グループは、農業や教育からインフラ、航空まで、7つの重要セクターにおいて大規模な投資・融資・戦略的パートナーシップを展開します。",
    cta1: "資金調達の相談",
    cta2: "サービスを見る",
    scroll: "スクロールして探索",
    m1: "運用資産額",
    m2: "資金提供プロジェクト",
    m3: "顧客満足度",
    m4: "主要セクター",
  },
  services: {
    eyebrow: "私たちの業務",
    title: "三つの構築方法",
    sub: "世界を支える企業のために設計された、機関投資レベルの資本。",
    s1t: "投資",
    s1d: "機関投資家クラスの出資と合弁事業で、有望な企業を業界のリーダーへと育てます。",
    s1f1: "出資・合弁事業",
    s1f2: "プロジェクト組成",
    s1f3: "長期成長",
    s2t: "融資",
    s2d: "中小企業から大企業まで、成長のために設計された大規模な商業融資を提供します。",
    s2f1: "50万ドル〜1億ドル超",
    s2f2: "迅速な承認",
    s2f3: "柔軟な返済",
    s3t: "パートナーシップ",
    s3d: "実践的なオペレーション支援とグローバルネットワークを備えた戦略的共同投資。",
    s3f1: "共同投資モデル",
    s3f2: "オペレーション支援",
    s3f3: "グローバルネットワーク",
  },
  sectors: {
    eyebrow: "投資対象",
    title: "7つのセクター。1つの基準。",
    sub: "次の世紀を形づくる産業に、大規模な資本を投じます。",
    ag: "農業", agd: "先端アグテックと規模を拡大する持続可能な農業。",
    edu: "教育", edud: "キャンパス開発と次世代の学習インフラ。",
    re: "不動産", red: "商業・住宅・複合開発への投資資本。",
    ind: "産業開発", indd: "製造工場、ロジスティクスパーク、工業団地。",
    inf: "インフラ", infd: "交通回廊、エネルギー資産、公共事業。",
    aut: "オートメーション", autd: "ロボティクスとAI駆動の製造システム。",
    avi: "航空", avid: "航空機リース、機隊融資、空港開発。",
  },
  loans: {
    eyebrow: "デットファイナンス",
    title: "本気のビジネスのための大規模融資。",
    desc: "50万ドルから1億ドル超まで。中小企業から大企業まで、迅速な承認・柔軟な返済・エクイティを守る条件で商業融資を組み立てます。",
    f1: "柔軟な返済条件",
    f2: "迅速な承認プロセス",
    f3: "競争力のある金利",
    f4: "希薄化なし",
    slider: "必要な調達額",
    cta: "融資相談を始める",
    steps: "相談 → 審査 → 承認 → 融資実行",
  },
  stats: { l1: "運用資産額", l2: "資金提供プロジェクト", l3: "顧客満足度", l4: "主要セクター" },
  marquee: ["投資", "農業", "融資", "教育", "パートナーシップ", "不動産", "インフラ", "オートメーション", "航空"],
  team: {
    eyebrow: "経営陣",
    title: "資本を動かす人々。",
    sub: "グローバル市場で数十年の経験を持つ、多様な経営チーム。",
    r1: "最高経営責任者（CEO）",
    r2: "上級副社長、グローバル投資",
    r3: "インフラ・デットファイナンス責任者",
    r4: "取締役、不動産・持続可能な開発",
    r5: "最高財務責任者（CFO）",
    r6: "法務・コンプライアンス責任者",
  },
  form: {
    eyebrow: "お問い合わせ",
    title: "プロジェクトについてお聞かせください。",
    sub: "概要をお送りいただければ、1営業日以内にご返信します。",
    name: "氏名",
    email: "メールアドレス",
    phone: "電話番号",
    company: "会社名",
    service: "ご関心のある分野",
    sector: "セクター",
    amount: "希望調達額",
    amountPh: "例：250万ドル",
    message: "プロジェクト内容",
    messagePh: "貴社の事業と資金ニーズを簡潔にお聞かせください…",
    pick: "セクターを選択",
    submit: "問い合わせを送信",
    submitting: "送信中…",
    success: "受け付けました。24時間以内にチームよりご連絡します。",
    error: "エラーが発生しました。もう一度お試しいただくか、WhatsAppでご連絡ください。",
    required: "氏名・メール・メッセージをご入力ください。",
    invalidEmail: "有効なメールアドレスを入力してください。",
    safe: "お客様の情報は常に秘密厳守で、100%安全に保護されます。",
  },
  contact: {
    eyebrow: "コンタクト",
    title: "直接ご相談ください。",
    whatsapp: "WhatsApp",
    waCta: "WhatsAppでチャット",
    email: "メール",
    emCta: "メールを送る",
    address: "オフィス",
    dir: "経路を調べる",
    hours: "月–金、9:00–18:00（東部標準時）",
  },
  footer: {
    tagline: "明日を形づくるセクターのための機関投資資本。",
    rights: "© 2026 パシフィック・インベストメント・グループ。全著作権所有。",
    privacy: "プライバシー",
    disclaimer: "パシフィック・インベストメント・グループは商業融資・投資サービスを提供します。すべてのお問い合わせは審査・承認の対象となります。",
  },
};

export const ko = {
  nav: { services: "서비스", sectors: "섹터", loans: "대출", team: "경영진", contact: "연락처", cta: "자금 조달 문의" },
  hero: {
    eyebrow: "캐나다 기관 자본",
    line1: "산업을 앞으로 나아가게 하는",
    line2: "자본의 힘",
    sub: "퍼시픽 인베스트먼트 그룹은 농업, 교육부터 인프라, 항공까지 7개 핵심 섹터에서 대규모 투자, 대출, 전략적 파트너십을 펼칩니다.",
    cta1: "자금 조달 문의",
    cta2: "서비스 살펴보기",
    scroll: "스크롤하여 탐색",
    m1: "투자 자본",
    m2: "지원 프로젝트",
    m3: "고객 만족도",
    m4: "핵심 섹터",
  },
  services: {
    eyebrow: "우리가 하는 일",
    title: "세 가지 방식의 파트너십",
    sub: "세상을 움직이는 기업을 위해 설계된 기관 자본.",
    s1t: "투자",
    s1d: "기관 수준의 지분 투자와 합작 투자로 유망한 기업을 업계 리더로 성장시킵니다.",
    s1f1: "지분 및 합작 투자",
    s1f2: "프로젝트 구조화",
    s1f3: "장기 성장",
    s2t: "대출",
    s2d: "중소기업부터 대기업까지, 성장을 위해 설계된 대규모 상업 대출.",
    s2f1: "50만~1억 달러 이상",
    s2f2: "빠른 승인",
    s2f3: "유연한 상환",
    s3t: "파트너십",
    s3d: "실질적인 운영 지원과 글로벌 네트워크를 갖춘 전략적 공동 투자.",
    s3f1: "공동 투자 모델",
    s3f2: "운영 지원",
    s3f3: "글로벌 네트워크",
  },
  sectors: {
    eyebrow: "투자 분야",
    title: "7개 섹터. 하나의 기준.",
    sub: "다음 세기를 만들어 갈 산업에 대규모 자본을 투입합니다.",
    ag: "농업", agd: "현대 애그테크와 규모화된 지속가능 농업.",
    edu: "교육", edud: "캠퍼스 개발과 차세대 학습 인프라.",
    re: "부동산", red: "상업, 주거 및 복합 개발 자본.",
    ind: "산업 개발", indd: "제조 공장, 물류 단지, 산업 단지.",
    inf: "인프라", infd: "교통 회랑, 에너지 자산, 공공 유틸리티.",
    aut: "자동화", autd: "로봇공학과 AI 기반 제조 시스템.",
    avi: "항공", avid: "항공기 리싱, 기체 금융, 공항 개발.",
  },
  loans: {
    eyebrow: "부채 금융",
    title: "진지한 비즈니스를 위한 대규모 대출.",
    desc: "50만 달러부터 1억 달러 이상까지, 중소기업과 대기업을 위한 상업 대출을 설계합니다 — 빠른 승인, 유연한 상환, 지분을 보호하는 조건.",
    f1: "유연한 상환 조건",
    f2: "빠른 승인 절차",
    f3: "경쟁력 있는 금리",
    f4: "지분 희석 없음",
    slider: "필요한 자금 규모",
    cta: "대출 문의 시작",
    steps: "문의 → 검토 → 승인 → 집행",
  },
  stats: { l1: "투자 자본", l2: "지원 프로젝트", l3: "고객 만족도", l4: "핵심 섹터" },
  marquee: ["투자", "농업", "대출", "교육", "파트너십", "부동산", "인프라", "자동화", "항공"],
  team: {
    eyebrow: "경영진",
    title: "자본 뒤에 있는 사람들.",
    sub: "글로벌 시장에서 수십 년의 경험을 지닌 다양한 경영 팀.",
    r1: "최고경영책임자 (CEO)",
    r2: "수석 부사장, 글로벌 투자",
    r3: "인프라 및 부채 금융 책임자",
    r4: "이사, 부동산 및 지속가능 개발",
    r5: "최고재무책임자 (CFO)",
    r6: "법률 및 컴플라이언스 총괄",
  },
  form: {
    eyebrow: "문의하기",
    title: "프로젝트에 대해 알려주세요.",
    sub: "몇 가지 정보를 공유해 주시면 영업일 기준 하루 안에 답변드립니다.",
    name: "성함",
    email: "이메일 주소",
    phone: "전화번호",
    company: "회사",
    service: "관심 서비스",
    sector: "섹터",
    amount: "금융 금액",
    amountPh: "예: 250만 달러",
    message: "프로젝트 소개",
    messagePh: "귀사의 사업과 자금 필요성을 간단히 알려주세요…",
    pick: "섹터 선택",
    submit: "문의 보내기",
    submitting: "전송 중…",
    success: "문의가 접수되었습니다 — 24시간 이내에 연락드리겠습니다.",
    error: "문제가 발생했습니다. 다시 시도하거나 WhatsApp으로 연락해 주세요.",
    required: "성함, 이메일, 메시지를 입력해 주세요.",
    invalidEmail: "유효한 이메일 주소를 입력해 주세요.",
    safe: "고객님의 정보는 항상 안전하게 보호되며 100% 기밀로 유지됩니다.",
  },
  contact: {
    eyebrow: "연락처",
    title: "직접 대화하세요.",
    whatsapp: "WhatsApp",
    waCta: "WhatsApp으로 대화",
    email: "이메일",
    emCta: "이메일 보내기",
    address: "사무실",
    dir: "길 찾기",
    hours: "월–금, 9:00–18:00 (동부시간)",
  },
  footer: {
    tagline: "내일을 만들어 갈 섹터를 위한 기관 자본.",
    rights: "© 2026 퍼시픽 인베스트먼트 그룹. 모든 권리 보유.",
    privacy: "개인정보 처리방침",
    disclaimer: "퍼시픽 인베스트먼트 그룹은 상업 금융 및 투자 서비스를 제공합니다. 모든 문의는 검토 및 승인 대상입니다.",
  },
};
